import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { DialogTitle, DialogContent, List, Typography, MenuItem } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const StyledLink = styled(Link)(() => ({
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingBottom: 1,
  '&:hover': {
    borderBottom: 'none'
  }
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  padding: '16px 24px 0'
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  paddingTop: 0,
  paddingBottom: 0
}));

export const StyledDialogContentList = styled(List)(() => ({
  paddingBottom: 0
}));

export const ProjectsTitle = styled(Typography)(() => ({
  fontWeight: 500,
  marginTop: 8
}));

export const DotIcon = styled(FiberManualRecordIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
  margin: '0 2px'
}));

export const DotsCntPopup = styled('div')(() => ({
  fontSize: 10,
  height: 10,
  marginRight: 4
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  paddingLeft: 0,
  paddingRight: 0,
  display: 'flex',
  flexWrap: 'wrap',
  whiteSpace: 'normal',
  alignItems: 'baseline'
}));

export const DialogContentLoading = styled(DialogContent)(() => ({
  height: 200,
  maxHeight: 'calc(100% - 64px)',
  minWidth: 250,
  maxWidth: '100%',
  position: 'relative',
  '& svg': {
    transform: 'initial'
  }
}));

export const CalibrationCertificateContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flex: 1
}));

export const CertificateTitle = styled(Typography)(() => ({
  flex: 1
}));

export const CertificateTitleBold = styled(Typography)(() => ({
  flex: 1,
  fontWeight: 500,
  marginTop: 8
}));

export const DownloadBtnAndDate = styled('div')(({ blurred }) => ({
  alignItems: 'center',
  display: 'flex',
  ...(blurred && { filter: 'blur(3px)' })
}));

export const DateDownload = styled(Typography)(() => ({
  cursor: 'pointer'
}));

export const Overlay = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
